import React, { useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';

import { green } from '@material-ui/core/colors';
import Radio from '@material-ui/core/Radio';


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      margin: 'auto',
      width: '300px',
      [theme.breakpoints.down('sm')]: {
          width: '100%',
      },
    },
  }));



const GreenRadio = withStyles({
  root: {
    color: green[400],
    '&$checked': {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Radio disabled {...props} />);

export default function RadioButtons({pin}) {
    const classes = useStyles();



  



  return (
    <div className={classes.root}>
           <GreenRadio
        checked={String(pin).length >= 1}
        name="radio-button-demo1"
      />
            <GreenRadio
        checked={String(pin).length >= 2}
        name="radio-button-demo2"
      />
      <GreenRadio
        checked={String(pin).length >= 3}
        name="radio-button-demo3"
      />
            <GreenRadio
        checked={String(pin).length >= 4}
        name="radio-button-demo4"
      />
           {/* <GreenRadio
        checked={String(pin).length === 5}
        name="radio-button-demo5"
      /> */}
    </div>
  );
}
